import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const ComputerLaptop: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    width={495}
    height={333}
    viewBox="0 0 495 333"
    fill="none"
    {...props}
  >
    <path
      fill="#80DFEA"
      d="M59.252 191.41h.022l-3.14-3.46-1.879 1.217s.086.15.225.385H11.163a5.65 5.65 0 0 0-5.648 5.648v91.705l-1.452 3.065 2.872 3.139h.021c1.036 1.153 2.53 1.9 4.207 1.9h43.915a5.65 5.65 0 0 0 5.648-5.648V195.2a5.629 5.629 0 0 0-1.474-3.78v-.01Z"
    />
    <path
      fill="#00448A"
      d="M57.853 192.051v94.161c0 3.117-2.54 5.659-5.648 5.659H8.28a5.592 5.592 0 0 1-4.4-2.125l-1.804-2.178.587-.844a4.12 4.12 0 0 1-.032-.512v-94.161a5.65 5.65 0 0 1 5.649-5.649h43.925c.214 0 .416 0 .62.043l-.022-.043 1.943-.149s1.826 2.221 1.869 2.285a5.602 5.602 0 0 1 1.238 3.513Z"
    />
    <path
      fill="#0072A6"
      d="M50.455 184.277H6.529a5.649 5.649 0 0 0-5.648 5.649v94.171a5.649 5.649 0 0 0 5.648 5.649h43.926a5.648 5.648 0 0 0 5.648-5.649v-94.171a5.648 5.648 0 0 0-5.648-5.649Z"
    />
    <path
      fill="#B2EBF2"
      d="M50.455 286.959H6.529a2.861 2.861 0 0 1-2.861-2.861v-94.161a2.862 2.862 0 0 1 2.861-2.862h43.925a2.862 2.862 0 0 1 2.862 2.862v94.161a2.861 2.861 0 0 1-2.861 2.861Z"
    />
    <path
      fill="#80DFEA"
      d="M3.668 235.751v48.346a2.862 2.862 0 0 0 2.861 2.862h43.915a2.862 2.862 0 0 0 2.862-2.862v-90.253C16.64 207.713 4.138 234.395 3.668 235.751Z"
    />
    <path
      fill="#FF612B"
      d="M28.492 254.404c8.857 0 16.037-7.18 16.037-16.037s-7.18-16.037-16.037-16.037-16.037 7.18-16.037 16.037 7.18 16.037 16.037 16.037Z"
    />
    <path
      fill="#fff"
      d="M35.101 238.772a1.313 1.313 0 0 0-1.313-1.398h-.502c.758 0 1.356-.63 1.313-1.399-.042-.715-.672-1.271-1.398-1.271H27.67l.299-.886c.341-1.057.47-2.199.299-3.299-.128-.801-.47-1.687-1.442-1.687-.63 0-1.185.47-1.313 1.1-.384 2.071-1.559 4.228-3.043 5.744a2.195 2.195 0 0 0-.587 1.516v5.574c0 .929.544 1.772 1.399 2.156a4.787 4.787 0 0 0 1.943.427h7.057c.716 0 1.356-.544 1.399-1.27a1.313 1.313 0 0 0-1.313-1.399h.672c.716 0 1.356-.544 1.4-1.27a1.314 1.314 0 0 0-1.314-1.399h.587c.715 0 1.356-.545 1.399-1.271l-.011.032Z"
    />
    <path
      fill="#80DFEA"
      d="M466.189 282.998c-15.428 0-27.931-12.503-27.931-27.932v-31.689c0-12.396 10.047-22.443 22.443-22.443h10.976c12.396 0 22.443 10.047 22.443 22.443v31.689c0 15.429-12.503 27.932-27.931 27.932Z"
    />
    <path
      fill="#009CBD"
      d="M463.38 280.19c-15.428 0-27.931-12.503-27.931-27.931v-31.69c0-12.396 10.047-22.443 22.443-22.443h10.976c12.397 0 22.444 10.047 22.444 22.443v31.69c0 15.428-12.503 27.931-27.932 27.931Z"
    />
    <path
      fill="#00BED5"
      d="M483.977 244.913v-31.69c0-4.313-1.239-8.328-3.353-11.755a22.28 22.28 0 0 0-11.756-3.353h-10.976c-12.396 0-22.443 10.047-22.443 22.443v31.69a27.79 27.79 0 0 0 4.858 15.738 27.793 27.793 0 0 0 15.738 4.858c15.429 0 27.932-12.503 27.932-27.931Z"
    />
    <path fill="#009CBD" d="M466.189 198.126h-5.328v21.771h5.328v-21.771Z" />
    <path
      fill="#002677"
      d="M463.531 209.006h-.011a2.659 2.659 0 0 0-2.659 2.658v9.845a2.659 2.659 0 0 0 2.659 2.658h.011a2.658 2.658 0 0 0 2.658-2.658v-9.845a2.658 2.658 0 0 0-2.658-2.658Z"
    />
    <path
      fill="#00448A"
      d="M460.861 211.675v9.834c0 .405.096.779.257 1.132.341.16.726.256 1.121.256a2.659 2.659 0 0 0 2.658-2.659v-9.833c0-.406-.096-.78-.256-1.132a2.658 2.658 0 0 0-1.121-.256 2.659 2.659 0 0 0-2.659 2.658Z"
    />
    <path
      fill="#80DFEA"
      d="M445.517 79.92H109.071c-3.939 0-8.007 1.804-8.146 3.609l-4.656 63.945h.225v168.922c0 5.264 2.573 9.908 6.523 12.78l-.128.396 3.235 1.388s.043.021.054.021l.117.053a15.883 15.883 0 0 0 6.012 1.185h274.892c8.744 0 15.823-7.089 15.823-15.823V147.175l47.684-63.646c1.356-1.805-1.239-3.61-5.178-3.61h-.011Z"
    />
    <path
      fill="#002677"
      d="M59.892.781h368.541c5.467 0 9.407 5.264 7.859 10.506l-37.071 125.798a10.654 10.654 0 0 1-10.229 7.645H99.344c-4.73 0-8.894-3.118-10.228-7.645L52.044 11.287C50.496 6.034 54.436.781 59.903.781h-.01Z"
    />
    <path
      fill="#000C44"
      d="M134.941 64.225c-22.304 24.14-34.06 53.203-30.366 72.508.331 1.719 1.25 5.029 2.125 8.007h282.292c4.73 0 8.894-3.117 10.228-7.644l37.071-125.798c1.548-5.253-2.392-10.506-7.858-10.506h-172.19s-75.818 14.232-121.302 63.443v-.01Z"
    />
    <path
      fill="#B2EBF2"
      d="M96.237 133.327 64.58 21.644c-.844-2.99 1.398-5.957 4.505-5.957h350.166c3.107 0 5.349 2.968 4.506 5.957l-31.658 111.683a4.677 4.677 0 0 1-4.506 3.406h-286.85a4.686 4.686 0 0 1-4.506-3.406Z"
    />
    <path
      fill="#80DFEA"
      d="m392.099 133.327 31.657-111.683c.844-2.99-1.399-5.957-4.506-5.957H208.57c-23.842 9.822-52.125 25.262-73.629 48.538-22.304 24.14-34.06 53.203-30.366 72.508h283.018a4.687 4.687 0 0 0 4.506-3.406Z"
    />
    <path
      fill="#D2C8BE"
      d="m397.726 148.2-.021-.032-.054-.054-2.722-2.722-1.324.555a8.107 8.107 0 0 0-1.623-.16H101.587a8.06 8.06 0 0 0-8.062 8.061v161.277c0 3.107.908 6.001 2.456 8.446l-.299.267 2.445 2.445.086.085.17.171c2.851 2.733 6.706 4.431 10.966 4.431H384.22c8.744 0 15.823-7.09 15.823-15.823V153.869a8.027 8.027 0 0 0-2.317-5.648v-.021Z"
    />
    <path
      fill="#EBE6E1"
      d="M381.604 328.333h-274.87c-8.745 0-15.824-7.09-15.824-15.824V151.232a8.06 8.06 0 0 1 8.061-8.061h290.396a8.061 8.061 0 0 1 8.061 8.061v161.277c0 8.745-7.09 15.824-15.824 15.824Z"
    />
    <path
      fill="#D2C8BE"
      d="M296.112 258.12H192.203a3.246 3.246 0 0 0-3.246 3.246v53.866a3.246 3.246 0 0 0 3.246 3.246h103.909a3.246 3.246 0 0 0 3.246-3.246v-53.866a3.246 3.246 0 0 0-3.246-3.246ZM361.637 163.18H128.898a5.488 5.488 0 0 0-5.488 5.488v74.12a5.488 5.488 0 0 0 5.488 5.488h232.739a5.488 5.488 0 0 0 5.488-5.488v-74.12a5.488 5.488 0 0 0-5.488-5.488Z"
    />
    <path
      fill="#FF612B"
      d="M286.353 62.441a17.874 17.874 0 0 0-4.356-9.962l-.011-.01c-2.434-2.787-5.595-4.741-9.108-5.82a22.39 22.39 0 0 0-3.865-.822c-6.908-.832-14.286 1.431-19.71 6.652l-5.135 4.944h-.011l-5.125-4.944c-9.524-9.171-24.675-9.171-32.683 0-.395.46-.758.93-1.11 1.41-6.107 8.53-3.598 20.297 5.243 27.162l32.874 25.508c.449.341 1.164.341 1.602 0 4.901-3.801 33.28-25.828 33.44-25.956 5.777-4.752 8.638-11.596 7.944-18.162h.011Z"
    />
  </Box>
)
export default ComputerLaptop
